import classNames from 'classnames';
import * as LucideIcons from 'lucide-react';
import './styles/chip.css';
import { useState } from 'react';

interface ChipProps {
  value: string | number;
  prependIcon?: keyof typeof LucideIcons;
  starDisplay?: boolean;
  crownDisplay?: boolean;
  dollarDisplay?: boolean;
  isGreen?: boolean;
  useWrapper?: boolean;
  isMasked?: boolean;
  onClick?: () => void;
}

function Chip(props: ChipProps) {
  const {
    value,
    prependIcon,
    starDisplay,
    crownDisplay,
    dollarDisplay,
    isGreen,
    useWrapper,
    isMasked,
    onClick,
  } = props;
  const chipClass = classNames('chip', {
    'chip-green': isGreen,
    'chip-wrapper': useWrapper,
    'chip-masked': isMasked,
  });

  const chipIconClass = classNames('chip-icon', {
    'chip-star-icon': starDisplay,
    'chip-crown-icon': crownDisplay,
    'chip-dollar-icon': dollarDisplay,
  });

  let IconComponent: any | React.ElementType = <></>;
  if (prependIcon) {
    IconComponent = LucideIcons[prependIcon] as React.ElementType;
  }

  const [hideValue, setHideValue] = useState<boolean>(isMasked ?? false);

  const handleClick = () => {
    if (isMasked) {
      setHideValue(!hideValue);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div className={chipClass} onClick={handleClick}>
      <span className="flex justify-center gap-[6px]">
        {prependIcon && <IconComponent className={chipIconClass} />}
        {isMasked && hideValue && <LucideIcons.EyeClosed className="chip-eye-icon" />}
        {isMasked && !hideValue && <LucideIcons.Eye className="chip-eye-icon" />}
        {isMasked && <span>{hideValue ? 'Click to view' : value}</span>}
        {!isMasked && value}
      </span>
    </div>
  );
}

export default Chip;
